import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=4a4be4df&"
import script from "./DashboardList.vue?vue&type=script&lang=ts&"
export * from "./DashboardList.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports